import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EMavenirDescriptorType = {
	modelWithoutDescriptor: 'MODEL_WITHOUT_DESCRIPTOR',
	modelForContainer: 'MODEL_FOR_CONTAINER',
	modelForVnfc: 'MODEL_FOR_VNFC',
} as const;

export const EMavenirDataModelType = {
	modelWithSchema: 'MODEL_WITH_SCHEMA',
	modelWithExistingSchema: 'MODEL_WITH_EXISTING_SCHEMA',
	modelWithoutSchema: 'MODEL_WITHOUT_SCHEMA',
} as const;

export const EMavenirDeviceType = {
	Pnf: 'PNF',
	Cnf: 'CNF',
	Vnfc: 'VNFC',
} as const;

export const EMavenirPnfType = {
	DU: 'DU',
	RRU: 'RRU',
	A2: 'A2',
	EUS: 'EUS',
} as const;

export const EMavenirElementType = {
	NF: 'NF',
	NFService: 'NF_SERVICE',
} as const;

export const EMavenirGroupBy = {
	LABEL: 'LABEL',
	TYPE: 'TYPE',
} as const;

export type TMavenirDescriptorType = TValueOfStringRecord<typeof EMavenirDescriptorType>
export type TMavenirDataModelType = TValueOfStringRecord<typeof EMavenirDataModelType>
export type TMavenirDeviceType = TValueOfStringRecord<typeof EMavenirDeviceType>
export type TMavenirPnfType = TValueOfStringRecord<typeof EMavenirPnfType>
export type TMavenirElementType = TValueOfStringRecord<typeof EMavenirElementType>
export type TMavenirGroupBy = TValueOfStringRecord<typeof EMavenirGroupBy>
